/**
 * SVG line defined by an implicit equation: intercept + slope_x*x + slope_y*y = 0
 * @param {{ axis, intercept, slopeX, slopeY, color, dashArray, strokeWidth, showRegion }} props
 */
export default function IntFigLine2D({
  axis,
  intercept, slopeX, slopeY,
  color = '#7fffd4',
  dashArray = '0 0',
  strokeWidth = 0.02,
  showRegion = false,
}) {
  let lx1 = -1, lx2 = 1, ly1 = -1, ly2 = 1;
  if (Math.abs(slopeX) > Math.abs(slopeY)) {
    lx1 = (-intercept - slopeX * -1) / slopeY;
    lx2 = (-intercept - slopeX *  1) / slopeY;
  } else {
    ly1 = (-intercept - slopeY * -1) / slopeX;
    ly2 = (-intercept - slopeY *  1) / slopeX;
  }

  const x1 = (lx1 - axis.min_x) / (axis.max_x - axis.min_x);
  const x2 = (lx2 - axis.min_x) / (axis.max_x - axis.min_x);
  const y1 = 1 - (ly1 - axis.min_y) / (axis.max_y - axis.min_y);
  const y2 = 1 - (ly2 - axis.min_y) / (axis.max_y - axis.min_y);

  return (
    <svg
      height="100%" width="100%"
      viewBox="0 0 1 1"
      preserveAspectRatio="none"
      style={{ position: 'absolute', inset: 0 }}
    >
      <line
        x1={x1} y1={y1} x2={x2} y2={y2}
        stroke={color} strokeWidth={strokeWidth} strokeDasharray={dashArray}
      />
    </svg>
  );
}
